import { InjectionToken } from '@angular/core';

export interface DsFullPageConfig {
  disabledAnimation?: boolean;
}
export const DS_FULL_PAGE_CONFIG = new InjectionToken<DsFullPageConfig>(
  'DS_FULL_PAGE_CONFIG',
);
